import { SetStateAction, Dispatch } from 'react';
import { IncentiveOption, ChannelOption, IncentiveLabel } from '../@types/Marketing';
import { NestedCheckboxData } from '../components/NestedCheckbox';

export function toCheckboxData(incentiveData: IncentiveOption[]): NestedCheckboxData {
  const checkboxData: NestedCheckboxData = {
    checked: false,
    label: IncentiveLabel.ALL,
    children: []
  };

  incentiveData.forEach((incentiveRec: IncentiveOption) => {
    const idx: number = checkboxData.children!.findIndex(
      (child: NestedCheckboxData) => child.label === incentiveRec.label
    );
    // @ts-ignore
    const subChild: NestedCheckboxData = {
      checked: incentiveRec.value === ChannelOption.YES,
      label: incentiveRec.name
    };
    if (idx === -1) {
      checkboxData.children!.push({
        checked: false,
        label: incentiveRec.label,
        children: [subChild]
      });
      checkboxData.children![0].checked = checkboxData.children![0].children!.every((child) => child.checked);
    } else {
      checkboxData.children![idx].children!.push(subChild);
      checkboxData.children![idx].checked = checkboxData.children![idx].children!.every((child) => child.checked);
    }
  });
  checkboxData.checked = checkboxData.children!.every((child) => child.checked);
  return checkboxData;
}

export function toIncentiveData(data: NestedCheckboxData): IncentiveOption[] {
  const incentive: IncentiveOption[] = [];
  data.children?.forEach((label: NestedCheckboxData) => {
    label.children?.forEach((child: NestedCheckboxData) =>
      incentive.push({
        name: child.label,
        value: child.checked ? ChannelOption.YES : ChannelOption.NO,
        label: label.label
      })
    );
  });
  return incentive;
}

export const alwaysSet = (fn: Dispatch<SetStateAction<any>>, v?: any) => () => fn(v);
